import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export function addInputEventListener(ref, type, listener) {
  if (!ref?.$refs?.input) {
    return;
  }
  // NOTE: b-input does not implement onKeydown event
  ref.$refs.input.addEventListener(type, listener);
}

export function bottomVisible() {
  const { scrollY } = window;
  const visible = document.documentElement.clientHeight;
  const pageHeight = document.documentElement.scrollHeight;
  const BUFFER = 20;
  // NOTE: Add a buffer to trigger loading a bit earlier
  const bottomOfPage = visible + scrollY + BUFFER >= pageHeight;
  return bottomOfPage || pageHeight < visible;
}

export function csvDownloader(rows = [], fileName = 'download') {
  const type = 'data:text/csv;charset=utf-8,\ufeff';
  const content = rows.map((row) => row
    .map(String)
    .map((v) => v.replaceAll('"', '""'))
    .map((v) => `"${v}"`)
    .join(',')).join('\r\n');
  const blob = new Blob([`\uFEFF${content}`], { type });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.csv`);

  link.click();
}

export function formatPrice(price) {
  if (!price) return '';
  return new Intl.NumberFormat(
    'zh-TW',
    {
      style: 'currency',
      currency: 'TWD',
      maximumFractionDigits: 0,
      roundingIncrement: 5,
    },
  ).format(price);
}

export function generateUniqueId() {
  const now = Date.now();
  const withRandom = now + Math.random();
  const sliceRandom = `${withRandom}`.slice(2, 11);
  return Math.floor(+sliceRandom);
}

export function getOptionRulesWithNote(rules = {}, note = '') {
  const result = [];
  const { max, min } = rules;
  if (max > 0 && !min) {
    result.push(`最多選${max}項`);
  } else if (!max && min > 0) {
    result.push(`最少選${min}項`);
  } else if (max > 0 && min > 0) {
    result.push(`最少選${min}項，最多選${max}項`);
  } else {
    result.push('不限制可選數量');
  }

  result.push(note);
  return result.filter(Boolean).join(' #');
}

export function inReceiveTime(times = []) {
  const now = dayjs();
  const hasTime = !!times?.length;
  if (!hasTime) {
    return false;
  }
  const isValidTime = ({ end_time: end, start_time: start }) => dayjs(end)
    .isSameOrAfter(now) && dayjs(start).isSameOrBefore(now);
  return times?.some((time) => isValidTime(time));
}

export function mapPhoneNumber(phone = '') {
  if (!phone) {
    return '';
  }
  const areaNumMap = {
    2: /^02|^03|^04|^05|^06|^07|^08/,
    3: /^037|^049|^089|^082/,
    4: /^09|^0826|^0836/,
  };
  return String(phone)
    .replace(/\D/g, '')
    .split('')
    .reduce((userPhone, letter, index) => {
      let phoneNum = userPhone;
      if (areaNumMap?.[index]?.test(phoneNum.replace('-', ''))) {
        phoneNum = phoneNum.indexOf('-') !== -1 && !/^09/.test(phoneNum)
          ? `${phoneNum.replace('-', '')}-`
          : `${phoneNum}-`;
      }
      return `${phoneNum}${letter}`;
    }, '');
}

export function numberInputHandler(event) {
  const keyCode = event.keyCode || event.which;
  const RESTRICTED_KEYCODES = [
    69, // NOTE: e
    109, // NOTE: Numpad -
    110, // NOTE: Numpad .
    189, // NOTE: -
    190, // NOTE: .
  ];
  if (RESTRICTED_KEYCODES.includes(keyCode)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}

export function removeInputEventListener(ref, type, listener) {
  if (ref?.$refs?.input) {
    return;
  }
  // NOTE: b-input does not implement onKeydown event
  ref.$refs.input.removeEventListener(type, listener);
}

export function roundToTwo(num) {
  return +`${Math.round(`${num}e+2`)}e-2`;
}

export default {
  addInputEventListener,
  bottomVisible,
  csvDownloader,
  formatPrice,
  generateUniqueId,
  getOptionRulesWithNote,
  inReceiveTime,
  mapPhoneNumber,
  numberInputHandler,
  removeInputEventListener,
  roundToTwo,
};
